import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

export function TemplatesIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      <rect
        x="44"
        y="24"
        width="72"
        height="112"
        rx="10"
        fill={c.n0}
        stroke={c.p200}
        strokeWidth="2"
      />
      <rect x="56" y="38" width="48" height="8" rx="4" fill={c.p500} />
      <rect
        x="56"
        y="58"
        width="48"
        height="16"
        rx="8"
        fill={c.a100}
        stroke={c.a400}
        strokeWidth="2"
        strokeDasharray="4 4"
      />
      <rect x="56" y="84" width="48" height="6" rx="3" fill={c.p200} />
      <rect x="66" y="96" width="28" height="6" rx="3" fill={c.p200} />
      <rect
        x="64"
        y="110"
        width="32"
        height="16"
        rx="8"
        fill={c.a100}
        stroke={c.a400}
        strokeWidth="2"
        strokeDasharray="4 4"
      />
    </Frame>
  );
}
